<div class="report-model">
    <div class="report-model-header">
        <div class="info">
            <h3>{{"reports.independentProperties" | translate}}</h3>
        </div>
    </div>
    <app-housevilla-inventory-properties [showLoader]="!loading"
        [tableColumns]="independentVillasColumns" [dataLength]="independentVillasCount"
        [tableData]="independentVillasdata" (pageEvent)="onPageEvent($event)" (sort)="sortData($event)"
        [allowExcelDownload]="true" (excelDownload)="downloadExcel($event, 'independent', 'a')"
        [downloadLoading]="downloadLoading['a']" [showEstaterText]="true" [type]="'independent'">
    </app-housevilla-inventory-properties>
</div>